<div class="container-fluid my-5  ">

  <div class="container text-center">
    <span class="fs-4 fw-medium text-secondary ">Atendemos afiliados de:</span>
  </div>
  <div class="slider my-lg-3   " >
    <div class="slide-track">
      <div class="slide mx-4" *ngFor="let imagen of imagenes; let i = index  ">
        <img ngSrc="assets/img/enterprises/{{imagen.url}}" height="100" width="150" alt="{{imagen.alt}}" />
      </div>

    </div>
  </div>
</div>

